import CampaignIcon from '@mui/icons-material/Campaign';
import ArchiveIcon from '@mui/icons-material/Archive';
import HearingIcon from '@mui/icons-material/Hearing';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
export const categories = [
    { name: 'Polish Trap/rap', icon: <CampaignIcon />,id:'78fl3l2j9qfX5cO9HUsvZ5' }, //1328
    { name: 'Polish underground', icon: <CampaignIcon />,id:'6KhaT4BRJzchmfBUj8DqIW' }, //1186
    { name: 'German Trap/rap', icon: <ArchiveIcon />,id:'602djI8cZPjZRKULyNNNoG' }, //777
    { name: 'English Trap/rap', icon: <AudiotrackIcon />,id:'7ykUd5lUhNRSTPlfcZENOo' }, //<691
    { name: 'English underground', icon: <AudiotrackIcon />,id:'4oaHLBPfa0FHBZqvCxpudp' }, //<1000
    { name: 'Polish R&B', icon: <HearingIcon />,id:'4fPRYC79iyBp7lbUYQfIw8' }, //<591
    { name: 'English R&B', icon: <HearingIcon />,id:'1SGxhqpkcWvvkp6Q56MW2A' }, //937 ref
    { name: 'Classical music', icon: <HearingIcon />,id:'1YVP4Mj16QW3KzVfpoUUYI' }, //581 ref

  ];
